import PropTypes from 'prop-types';

import { Chip, ListItemText, IconButton, CircularProgress, Box } from '@mui/material';

import { Close as CloseIcon } from '@mui/icons-material';

const Details = ({ item, isLoading, handleClose, handleLinkClick }) => (
  <Box
    sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
  >
    <ListItemText>
      <div>
        <span>Your {item.for} request has been </span>
        <strong>{item.status}</strong>
      </div>

      <Box sx={{ display: 'flex' }}>
        <Chip
          size="small"
          color="primary"
          variant="outlined"
          component="span"
          onClick={handleLinkClick}
          label="Click to see details"
          sx={{
            fontSize: 12,
            height: 'auto',
            border: 'none',
            backgroundColor: 'rgba(64, 111, 209, 0.08)',
          }}
        />

        {isLoading && (
          <CircularProgress
            sx={{ marginLeft: 5 }}
            color="primary"
            size={10}
            aria-label="Loading request details"
          />
        )}
      </Box>
    </ListItemText>
    <IconButton
      size="small"
      onClick={handleClose}
      sx={{
        '& svg': {
          width: 14,
          height: 14,
        },
      }}
      aria-label="close"
    >
      <CloseIcon />
    </IconButton>
  </Box>
);

Details.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  handleLinkClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default Details;
